import './App.css';
import Routes from './route/router';
import './assets/css/styles.css';
import './assets/css/intro-about.css';
import './assets/css/how-it-works-styles.css';

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
